import { render } from "./ButtonLinkElement.vue?vue&type=template&id=cc2a1370&scoped=true"
import script from "./ButtonLinkElement.vue?vue&type=script&lang=js"
export * from "./ButtonLinkElement.vue?vue&type=script&lang=js"

import "./ButtonLinkElement.vue?vue&type=style&index=0&id=cc2a1370&scoped=true&lang=css"

import exportComponent from "../../../../peelochat-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc2a1370"]])

export default __exports__